// Tu Once, por encargo — personalización OPCIONAL y mensajería de entrega.
// Sin apps externas. Usa line item properties nativas de Shopify.
//
// IMPORTANTE (por qué las propiedades se mantienen "en vivo"): el tema arma los datos del pedido
// (new FormData(form)) antes de que un listener de este script pueda agregar nada al enviar. Por eso
// los inputs ocultos de propiedades se actualizan CADA VEZ que cambia la selección, y además se
// revalidan en el clic y en el submit a nivel documento (fase de captura, antes que el tema).
//
// Regla de disponibilidad: Once Ideal no estampa nada. Solo una pieza ya estampada de fábrica (jugador de fábrica)
// o una pieza sin personalizar pueden salir "Disponible" según el stock de la variante. Cualquier dorsal pedido
// (Añade el tuyo, o jugador de la lista por encargo) lo estampa el proveedor, así que SIEMPRE es "Por encargo".
//
// Qué hace "Elegir un jugador":
//   - Jugador de fábrica (la pieza ya viene estampada, tiene stock propio): el valor de la opción de
//     variante Dorsal (antes Personalizacion). La opción está oculta con CSS; este script selecciona esa
//     variante. No agrega propiedades Nombre/Número (la variante ya aparece en el carrito).
//   - Jugador por encargo (lista del metafield) o "Añade el tuyo": se usa la variante Sin dorsal y se
//     agregan Nombre/Número como propiedades. "Añade el tuyo" pide confirmación en un modal.
//   - No elegir nada: variante Sin dorsal, sin propiedades.
// Propiedades visibles al cliente: Nombre y Número (el número se guarda tal como se escribió: 00, 09, 7).
// Las que empiezan con guion bajo (_Entrega, _Personalización, _Dorsal) Shopify las oculta en carrito y checkout,
// pero se ven en el pedido del admin.
// Reglas del dorsal (nombre máx. 12, número 0-99) en assets/once-ideal-dorsal.js.
// Este script NO modifica el texto del botón de compra (lo maneja el tema).
(function () {
  var script = document.currentScript;
  if (!script) return;
  var blockId = script.getAttribute('data-block-id');
  var sectionId = script.getAttribute('data-section-id');
  if (!blockId || !sectionId) return;

  var AXIS_NAMES = ['Personalizacion', 'Personalización', 'Dorsal'];
  var PLAIN = 'Sin dorsal';
  var SUBMIT_SELECTOR = 'button[type=submit], [data-testid=standalone-add-to-cart] button, .add-to-cart-button';

  // El botón de compra se pone rojo cuando la selección es "Por encargo". Se hace con CSS ligado al estado del
  // bloque (no con una clase en el botón) porque el tema reemplaza el botón al cambiar de variante.
  if (!document.getElementById('once-ideal-cta-style')) {
    var st = document.createElement('style');
    st.id = 'once-ideal-cta-style';
    st.textContent =
      '.shopify-section:has(.once-ideal-preorder[data-effective-stocked=false]) button[name=add] {' +
      'background: #E4172A !important; border-color: #E4172A !important; color: #ffffff !important; }';
    document.head.appendChild(st);
  }

  function currentForm() {
    return document.getElementById('BuyButtons-ProductForm-' + sectionId);
  }

  function init() {
    var D = window.OnceIdealDorsal;
    var wrapper = document.getElementById('OnceIdealPreorder-' + blockId);
    if (!D || !wrapper || !currentForm()) return;
    if (wrapper.hasAttribute('data-once-ideal-bound')) return;
    wrapper.setAttribute('data-once-ideal-bound', '');

    // Stock de la variante seleccionada (sin tomar en cuenta la personalización).
    var baseStocked = wrapper.getAttribute('data-stocked-available') === 'true';
    var entregaLabel = wrapper.getAttribute('data-entrega-label') || '';
    var fields = wrapper.querySelector('[data-once-ideal-fields]');
    var modeInputs = wrapper.querySelectorAll('[data-once-ideal-mode]');
    var panelPlayer = wrapper.querySelector('[data-once-ideal-panel=jugador]');
    var panelOwn = wrapper.querySelector('[data-once-ideal-panel=propio]');
    var playerSelect = wrapper.querySelector('[data-once-ideal-player]');
    var nameInput = wrapper.querySelector('[data-once-ideal-name]');
    var numberInput = wrapper.querySelector('[data-once-ideal-number]');
    var nameCount = wrapper.querySelector('[data-once-ideal-name-count]');
    var numberCount = wrapper.querySelector('[data-once-ideal-number-count]');
    var previewEl = wrapper.querySelector('[data-once-ideal-preview]');
    var errorEl = wrapper.querySelector('[data-once-ideal-error]');
    var resetButton = wrapper.querySelector('[data-once-ideal-reset]');
    var modal = document.getElementById('OnceIdealConfirmModal-' + blockId);
    var confirmCheckbox = modal ? modal.querySelector('[data-once-ideal-confirm-checkbox]') : null;
    var confirmBtn = modal ? modal.querySelector('[data-once-ideal-confirm-btn]') : null;
    var summaryName = modal ? modal.querySelector('[data-once-ideal-summary-name]') : null;
    var summaryNumber = modal ? modal.querySelector('[data-once-ideal-summary-number]') : null;
    var closeButtons = modal ? modal.querySelectorAll('[data-once-ideal-modal-close]') : [];
    var availabilityNode = wrapper.querySelector('[data-once-ideal-availability]');
    var availabilityBadge = wrapper.querySelector('[data-once-ideal-availability-badge]');
    var deliveryNode = wrapper.querySelector('[data-once-ideal-delivery]');
    var preorderHint = wrapper.querySelector('[data-once-ideal-preorder-hint]');
    var preorderExceptions = wrapper.querySelector('[data-once-ideal-preorder-exceptions]');

    var mode = playerSelect ? 'jugador' : 'propio';
    var confirmed = false;

    // ---- Opción de variante del dorsal (oculta con CSS) ----
    function getPicker() {
      return (
        document.querySelector('variant-picker[data-section-id="' + sectionId + '"]') ||
        document.querySelector('variant-picker')
      );
    }
    function axisControl() {
      var picker = getPicker();
      if (!picker) return null;
      var radios = Array.prototype.filter.call(
        picker.querySelectorAll('input[type=radio][data-option-name]'),
        function (r) { return AXIS_NAMES.indexOf(r.getAttribute('data-option-name')) !== -1; }
      );
      if (radios.length) return { kind: 'radio', radios: radios };
      var selects = picker.querySelectorAll('select');
      for (var k = 0; k < selects.length; k++) {
        var first = selects[k].options[0];
        if (first && AXIS_NAMES.indexOf(first.getAttribute('data-option-name')) !== -1) {
          return { kind: 'select', select: selects[k] };
        }
      }
      return null;
    }
    function axisValue() {
      var c = axisControl();
      if (!c) return null;
      if (c.kind === 'radio') {
        var on = c.radios.filter(function (r) { return r.checked; })[0];
        return on ? on.value : null;
      }
      return c.select.value;
    }
    function setAxis(value) {
      var c = axisControl();
      if (!c) return;
      if (c.kind === 'radio') {
        var target = c.radios.filter(function (r) { return r.value === value; })[0];
        if (!target || target.checked) return;
        target.checked = true;
        target.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        if (c.select.value === value) return;
        c.select.value = value;
        c.select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    // Lo que el cliente eligió ahora mismo. Vacío = sin dorsal.
    function current() {
      if (!fields) return { name: '', number: '', source: '', axis: PLAIN };
      if (mode === 'jugador' && playerSelect) {
        var opt = playerSelect.options[playerSelect.selectedIndex];
        if (!opt || !opt.value) return { name: '', number: '', source: '', axis: PLAIN };
        var axisVal = opt.getAttribute('data-axis-value') || '';
        return {
          name: D.cleanName(opt.getAttribute('data-name') || '').trim(),
          number: D.cleanNumber(opt.getAttribute('data-number') || ''),
          source: axisVal ? 'Fábrica' : 'Jugador',
          axis: axisVal || PLAIN
        };
      }
      return {
        name: nameInput ? D.cleanName(nameInput.value).trim() : '',
        number: numberInput ? D.cleanNumber(numberInput.value) : '',
        source: 'Propio',
        axis: PLAIN
      };
    }
    function hasDorsal(s) { return !!(s.name || s.number); }
    function needsConfirm(s) { return hasDorsal(s) && s.source === 'Propio'; }
    // Un dorsal que no es de fábrica lo estampa el proveedor: siempre por encargo.
    function needsSupplierStamp(s) { return hasDorsal(s) && s.source !== 'Fábrica'; }

    // Pone la variante oculta que corresponde a lo elegido.
    function applyAxis() {
      setAxis(current().axis);
    }

    // ---- Propiedades del artículo (se mantienen siempre al día en el formulario) ----
    function syncProperties() {
      var form = currentForm();
      if (!form) return;
      var existing = form.querySelectorAll('[data-once-ideal-injected]');
      for (var j = 0; j < existing.length; j++) {
        existing[j].remove();
      }
      function addHidden(name, value) {
        if (!value) return;
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        input.setAttribute('data-once-ideal-injected', '');
        form.appendChild(input);
      }
      var s = current();
      if (hasDorsal(s)) {
        if (s.source === 'Fábrica') {
          // La variante (Dorsal: jugador) ya aparece en el carrito; solo se marca el origen para el admin.
          addHidden('properties[_Dorsal]', 'Fábrica');
        } else {
          // El número se guarda exactamente como se escribió (00, 09, 7): no se le quitan los ceros.
          var numberText = s.number;
          // Visibles para el cliente en carrito y checkout.
          addHidden('properties[Nombre]', s.name);
          addHidden('properties[Número]', numberText);
          // Ocultas (guion bajo): mantienen distintas las personalizaciones en el carrito y avisan al admin.
          addHidden('properties[_Personalización]', [s.name, numberText].filter(Boolean).join(' · '));
          addHidden('properties[_Dorsal]', s.source);
        }
      }
      // Oculta para el cliente; visible en el pedido del admin. Refleja la disponibilidad real.
      addHidden('properties[_Entrega]', entregaLabel);
    }

    // ---- Disponibilidad / mensaje de entrega ----
    var stockVariants = [];
    try {
      stockVariants = JSON.parse(wrapper.getAttribute('data-variant-stock') || '[]');
    } catch (error) {
      stockVariants = [];
    }

    function updateAvailability(isStocked) {
      var delivery = isStocked
        ? 'Disponible · Entrega estimada 3–5 días hábiles'
        : 'Por encargo · hasta 20 días hábiles';
      entregaLabel = delivery;
      wrapper.setAttribute('data-entrega-label', delivery);
      wrapper.setAttribute('data-effective-stocked', isStocked ? 'true' : 'false');
      if (availabilityNode) {
        availabilityNode.classList.toggle('once-ideal-preorder__availability--available', isStocked);
        availabilityNode.classList.toggle('once-ideal-preorder__availability--preorder', !isStocked);
      }
      if (availabilityBadge) {
        availabilityBadge.textContent = isStocked ? 'DISPONIBLE' : 'POR ENCARGO';
        availabilityBadge.classList.toggle('once-ideal-preorder__badge--preorder', !isStocked);
      }
      if (deliveryNode) {
        deliveryNode.textContent = isStocked
          ? 'Entrega estimada: 3–5 días hábiles'
          : 'Llega en hasta 20 días hábiles desde tu pago';
      }
      if (preorderHint) preorderHint.hidden = isStocked;
      if (preorderExceptions) preorderExceptions.hidden = isStocked;
    }

    // Combina el stock de la variante con lo que el cliente personalizó y deja las propiedades al día.
    function renderAvailability() {
      updateAvailability(baseStocked && !needsSupplierStamp(current()));
      syncProperties();
    }

    function syncAvailabilityFromVariant(variantId) {
      if (!variantId || !stockVariants.length) return;
      var selected = stockVariants.find(function (item) {
        return String(item.id) === String(variantId);
      });
      if (!selected) return;
      baseStocked = selected.managed === 'shopify' && Number(selected.qty) > 0;
      wrapper.setAttribute('data-stocked-available', baseStocked ? 'true' : 'false');
      renderAvailability();
    }

    // Contadores "0 / 12", "0 / 2", vista previa (solo cuando hay algo elegido) y disponibilidad.
    function refreshDorsal() {
      if (nameCount && nameInput) nameCount.textContent = nameInput.value.length + ' / ' + D.NAME_MAX;
      if (numberCount && numberInput) numberCount.textContent = numberInput.value.length + ' / 2';
      var s = current();
      if (previewEl) {
        previewEl.hidden = !hasDorsal(s);
        D.renderPreview(previewEl, s.name, s.number);
      }
      renderAvailability();
    }

    // Por defecto la compra va sin dorsal. Si el enlace trae una variante con jugador de fábrica, se refleja en el menú.
    function initialAxisSync() {
      var v = axisValue();
      if (v === null || v === PLAIN) return;
      var hasVariantParam = new URLSearchParams(window.location.search).has('variant');
      if (hasVariantParam && playerSelect) {
        for (var q = 0; q < playerSelect.options.length; q++) {
          if (playerSelect.options[q].getAttribute('data-axis-value') === v) {
            playerSelect.selectedIndex = q;
            refreshDorsal();
            return;
          }
        }
      }
      setAxis(PLAIN);
    }

    function showError(msg) {
      if (errorEl) {
        errorEl.textContent = msg;
        errorEl.hidden = false;
      }
    }
    function clearError() {
      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }
    }

    // Revisa lo escrito en "Añade el tuyo". Vacío es válido (va sin dorsal).
    function checkOwn() {
      var rawName = nameInput ? nameInput.value.trim() : '';
      var rawNumber = numberInput ? numberInput.value.trim() : '';
      if (rawNumber !== '' && !/^[0-9]{1,2}$/.test(rawNumber)) {
        return { message: 'El número va de 0 a 99 (máximo 2 dígitos).', el: numberInput };
      }
      if (rawName !== '' && !D.hasLetter(rawName)) {
        return { message: 'El nombre debe incluir al menos una letra.', el: nameInput };
      }
      return null;
    }

    function setMode(next) {
      mode = next;
      if (panelPlayer) panelPlayer.hidden = mode !== 'jugador';
      if (panelOwn) panelOwn.hidden = mode !== 'propio';
      // Al cambiar de opción se limpia la otra, como en Adidas.
      if (mode === 'propio' && playerSelect) playerSelect.value = '';
      if (mode === 'jugador') {
        if (nameInput) nameInput.value = '';
        if (numberInput) numberInput.value = '';
      }
      clearError();
      confirmed = false;
      refreshDorsal();
      applyAxis();
    }

    for (var m = 0; m < modeInputs.length; m++) {
      modeInputs[m].addEventListener('change', function () {
        if (this.checked) setMode(this.value);
      });
    }
    if (playerSelect) {
      playerSelect.addEventListener('change', function () {
        clearError();
        confirmed = false;
        refreshDorsal();
        applyAxis();
      });
    }
    if (numberInput) {
      numberInput.addEventListener('input', function () {
        var clean = D.cleanNumber(this.value);
        if (clean !== this.value) this.value = clean;
        clearError();
        confirmed = false;
        refreshDorsal();
      });
    }
    if (nameInput) {
      // Máx. 12 caracteres; solo letras, acentos, espacios, guiones y apóstrofe (respeta mayúsculas/minúsculas).
      nameInput.addEventListener('input', function () {
        var clean = D.cleanName(this.value);
        if (clean !== this.value) this.value = clean;
        clearError();
        confirmed = false;
        refreshDorsal();
      });
    }
    if (resetButton) {
      resetButton.addEventListener('click', function () {
        if (playerSelect) playerSelect.value = '';
        if (nameInput) nameInput.value = '';
        if (numberInput) numberInput.value = '';
        if (modeInputs.length) modeInputs[0].checked = true;
        setMode(playerSelect ? 'jugador' : 'propio');
      });
    }

    // The variant picker exposes the resolved variant id on the changed option.
    document.addEventListener('change', function (event) {
      if (!wrapper.isConnected) return;
      var target = event.target;
      if (!target) return;
      var selectedOption = target;
      if (target instanceof HTMLSelectElement) {
        selectedOption = target.options[target.selectedIndex];
      }
      if (!selectedOption || !selectedOption.dataset || !selectedOption.dataset.variantId) return;
      if (!selectedOption.closest('variant-picker')) return;
      syncAvailabilityFromVariant(selectedOption.dataset.variantId);
    }, true);

    // ---- Modal de confirmación (solo para "Añade el tuyo") ----
    function openModal(s) {
      if (!modal) return;
      if (summaryName) summaryName.textContent = s.name || '—';
      if (summaryNumber) summaryNumber.textContent = s.number !== '' ? s.number : '—';
      if (confirmCheckbox) confirmCheckbox.checked = false;
      if (confirmBtn) confirmBtn.setAttribute('disabled', '');
      if (typeof modal.showModal === 'function') {
        modal.showModal();
      } else {
        modal.setAttribute('open', '');
      }
    }
    function closeModal() {
      if (!modal) return;
      if (typeof modal.close === 'function') {
        modal.close();
      } else {
        modal.removeAttribute('open');
      }
    }

    if (confirmCheckbox && confirmBtn) {
      confirmCheckbox.addEventListener('change', function () {
        if (confirmCheckbox.checked) {
          confirmBtn.removeAttribute('disabled');
        } else {
          confirmBtn.setAttribute('disabled', '');
        }
      });
      confirmBtn.addEventListener('click', function () {
        if (!confirmCheckbox.checked) return;
        confirmed = true;
        closeModal();
        var f = currentForm();
        if (!f) return;
        if (typeof f.requestSubmit === 'function') {
          f.requestSubmit();
        } else {
          f.submit();
        }
      });
    }
    for (var i = 0; i < closeButtons.length; i++) {
      closeButtons[i].addEventListener('click', closeModal);
    }

    // Si es "Añade el tuyo" y aún no confirmó, frena el envío y abre el modal.
    // Devuelve true cuando detuvo el envío. Elegir jugador o no elegir nada pasa directo.
    function gate(evt) {
      var s = current();
      if (!needsConfirm(s) || confirmed) return false;
      evt.preventDefault();
      evt.stopImmediatePropagation();
      var problem = checkOwn();
      if (problem) {
        showError(problem.message);
        if (problem.el) problem.el.focus();
        return true;
      }
      clearError();
      openModal(s);
      return true;
    }

    // A nivel documento y en captura: corre antes que cualquier listener del tema y no se pierde
    // si el tema reemplaza el botón o el formulario.
    document.addEventListener('click', function (evt) {
      var form = currentForm();
      var t = evt.target;
      if (!form || !(t instanceof Element)) return;
      var btn = t.closest(SUBMIT_SELECTOR);
      if (!btn || !form.contains(btn)) return;
      syncProperties();
      gate(evt);
    }, true);

    document.addEventListener('submit', function (evt) {
      var form = currentForm();
      if (!form || evt.target !== form) return;
      if (gate(evt)) return;
      syncProperties();
      confirmed = false;
    }, true);

    // Estado inicial (al final, cuando ya existe todo lo anterior).
    refreshDorsal();
    initialAxisSync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Horizon re-renders the section via the Section Rendering API on variant change;
  // re-bind after any such update in case the block was replaced.
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('pagereload', init);
})();
